<div class="spinner-container">    
    <div class="heading">
        Loading...
    </div>
    <span class="spinner focus--content" tabindex="-1">
        <svg class="m-ic" [ngClass]="{'spin' : isProcessing}"><use xlink:href="#ic-refresh-dark" href="#ic-refresh-dark"></use></svg>
    </span>
</div>